import { FunctionComponent } from 'react'
import Modal from 'components/shared/Modal'
import { URL_FC_KNOWLEDGE_NOTIFY_SIGNUP } from '../constants/links'

interface ComingSoonDialogProps {
  open: boolean
  onClose: () => void
}

const ComingSoonDialog: FunctionComponent<ComingSoonDialogProps> = ({ open, onClose }) => (
  <Modal
    open={open}
    onClose={onClose}
    title='Content launching soon!'
    size='small'
    actions={
      <button className='pointer bg-suez-canal br3 ph6 pv4 white f5 bn hover-o-90' onClick={onClose}>
        Close
      </button>
    }
  >
    <a href={URL_FC_KNOWLEDGE_NOTIFY_SIGNUP} target='_blank' rel='noreferrer'>Sign up</a>{' '}
    to be notified when it&apos;s ready (existing FC Knowledge subscribers will automatically receive updates in their daily briefings).
  </Modal>
)

export default ComingSoonDialog
